import React from 'react';

const DistributorReportStats = ({ kpi = {}, loading = false, hideDistributorCount = false, isDetailPage = false }) => {
  const moneyFormatIndia = (amount) => {
    if (!amount) return '0';
    const num = parseFloat(amount);
    if (isNaN(num)) return '0';
    return num.toLocaleString('en-IN', { maximumFractionDigits: 2 });
  };

  const widgetBoxStyle = {
    minHeight: '78px',
    height: '100%',
    padding: '10px 16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: 0,
    borderRadius: '6px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
  };

  const titleStyle = {
    fontSize: '14.5px',
    fontWeight: '600',
    color: '#ffffff',
    letterSpacing: '0.2px',
    display: 'block',
    textAlign: 'left',
    width: '100%',
    lineHeight: '1.2',
  };

  const valueStyle = {
    fontSize: '26px',
    fontWeight: '700',
    color: '#ffffff',
    lineHeight: '1.1',
    display: 'block',
    textAlign: 'right',
    width: '100%',
    marginTop: '4px',
  };

  const isDetail = isDetailPage || hideDistributorCount;
  const countSlots = isDetail ? 6 : 7;
  const colClass = isDetail ? "col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-3" : "col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-3";

  if (loading) {
    return (
      <div className="row mb-3">
        {Array.from({ length: countSlots }).map((_, i) => (
          <div key={`stat-skeleton-${i}`} className={colClass}>
            <div className="widget widget-stats bg-light inverse-mode" style={widgetBoxStyle}>
              <div style={{ textAlign: 'left', width: '100%' }}>
                <div className="skeleton-text" style={{ width: '80px', height: '14px' }}></div>
              </div>
              <div style={{ textAlign: 'right', width: '100%', marginTop: '4px' }}>
                <div className="skeleton-text" style={{ width: '50px', height: '24px', float: 'right' }}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row mb-3">
      {/* 1. Total Distributors (Royal Navy Blue) */}
      {!isDetail && (
        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-3">
          <div className="widget widget-stats inverse-mode" style={{ ...widgetBoxStyle, background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
            <div style={{ textAlign: 'left', width: '100%' }}>
              <span style={titleStyle}>Distributors</span>
            </div>
            <div style={{ textAlign: 'right', width: '100%' }}>
              <span style={valueStyle}>{Number(kpi.totalDistributors || 0).toLocaleString()}</span>
            </div>
          </div>
        </div>
      )}

      {/* 2. Paid Subscriptions (Vibrant Emerald Green) */}
      <div className={colClass}>
        <div className="widget widget-stats bg-gradient-green inverse-mode" style={widgetBoxStyle}>
          <div style={{ textAlign: 'left', width: '100%' }}>
            <span style={titleStyle}>Subscriptions</span>
          </div>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <span style={valueStyle}>{Number(kpi.totalSubscriptions || 0).toLocaleString()}</span>
          </div>
        </div>
      </div>

      {/* 3. Conversion Rate (Warm Coral Orange) */}
      <div className={colClass}>
        <div className="widget widget-stats bg-gradient-orange inverse-mode" style={widgetBoxStyle}>
          <div style={{ textAlign: 'left', width: '100%' }}>
            <span style={titleStyle}>Conversion Rate</span>
          </div>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <span style={valueStyle}>{kpi.conversionRate || 0}%</span>
          </div>
        </div>
      </div>

      {/* 4. Gross Sales (Royal Purple / Violet) */}
      <div className={colClass}>
        <div className="widget widget-stats bg-gradient-purple inverse-mode" style={widgetBoxStyle}>
          <div style={{ textAlign: 'left', width: '100%' }}>
            <span style={titleStyle}>Gross Sales</span>
          </div>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <span style={valueStyle}>₹{moneyFormatIndia(kpi.grossRevenue)}</span>
          </div>
        </div>
      </div>

      {/* 5. Commission (Ocean Teal / Cyan) */}
      <div className={colClass}>
        <div className="widget widget-stats bg-gradient-teal inverse-mode" style={widgetBoxStyle}>
          <div style={{ textAlign: 'left', width: '100%' }}>
            <span style={titleStyle}>Commission</span>
          </div>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <span style={valueStyle}>₹{moneyFormatIndia(kpi.totalCommission)}</span>
          </div>
        </div>
      </div>

      {/* 6. Average Order Value (Deep Indigo) */}
      <div className={colClass}>
        <div className="widget widget-stats inverse-mode" style={{ ...widgetBoxStyle, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <div style={{ textAlign: 'left', width: '100%' }}>
            <span style={titleStyle}>Avg Order Value</span>
          </div>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <span style={valueStyle}>₹{moneyFormatIndia(kpi.avgOrderValue)}</span>
          </div>
        </div>
      </div>

      {/* 7. Active Subscriptions (Rose Pink) */}
      <div className={colClass}>
        <div className="widget widget-stats inverse-mode" style={{ ...widgetBoxStyle, background: 'linear-gradient(135deg, #f857a6 0%, #ff5858 100%)' }}>
          <div style={{ textAlign: 'left', width: '100%' }}>
            <span style={titleStyle}>Active Subs</span>
          </div>
          <div style={{ textAlign: 'right', width: '100%' }}>
            <span style={valueStyle}>{Number(kpi.activeSubscriptions || 0).toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorReportStats;
